import React, { useEffect, useState } from "react";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import DashTable from "./DashTable";
import DialogModal from "../../../Component/DigitalMarketing/DialogModal";
import { TipsLabel } from "./Utils/TableHeadlist";
import {
  useAddWellnessTipsMutation,
  useGetWellnessTipsListQuery,
  useUpdateWellnessTipsMutation,
} from "../../../Service/wellnessTips";
import Toast from "../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import { useGetAllBranchesQuery } from "../../../Service/Masters";

function TipList(props) {
  const {
    open,
    handleClose,
    setsubmit,
    submit,
    pagi,
    handleOpen,
    Option_list,
  } = props;

  const initialstate = {
    id: null,
    tipsTitle: "",
    tipsDescription: "",
    wellnessImage: "",
    categoryId: "",
    activeStatus: "",
    scheduleDate: "",
  };

  const [tip, setTip] = useState(initialstate);
  const { open: open1, message, openSnackBar, type } = useSnackbar();
  const [addWellnessTips, { isLoading: isLoadingAdd }] = useAddWellnessTipsMutation();
  const [updateWellnessTips] = useUpdateWellnessTipsMutation();

  const { data: response, isLoading: loadinglist, refetch } = useGetWellnessTipsListQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });

  const { data: branchOptions, isLoading: branchLoading } = useGetAllBranchesQuery({
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (!open) {
      setTip(initialstate);
    }
  }, [open]);

  const OnChange = (event) => {
    const { name, value, files } = event.target;
    setsubmit(false);
    if (name === "wellnessImage") {
      setTip((prevState) => ({ ...prevState, [name]: files[0] }));
    } else {
      setTip((prevState) => ({ ...prevState, [name]: value }));
    }
  };
  
  const onSubmit = async () => {
    setsubmit(true);
    let data: any = { ...tip };

    var form_data = new FormData();
    for (var key in data) {
      form_data.append(key, data[key]);
    }

    if (data.tipsTitle && data.tipsDescription && data.categoryId && data.scheduleDate) {
      if (!data.id) {
        try {
          const payload = await addWellnessTips(form_data).unwrap();
          openSnackBar("Added successfully");
          handleClose();
          refetch();
        } catch (error: any) {
          openSnackBar(error.data.error, "error");
        }
      } else {
        try {
          const payload = await updateWellnessTips({ id: data.id, form_data }).unwrap();
          handleClose();
          refetch();
          openSnackBar("Updated successfully");
        } catch (error: any) {
          openSnackBar(error.data.error, "error");
        }
      }
    } else {
      openSnackBar("Please fill all data before submit!", "error");
    }
  };

  const onHandleEdit = (data) => {
    handleOpen();
    setTip({ ...data });
  };

  return (
    <>
      <Toast open={open1} type={type} message={message} />
      <DialogModal
        title={tip?.id ? "Update Wellness tips" : "Add Wellness tips"}
        formlist={TipsLabel}
        opt_list={Option_list}
        branchOptions={branchOptions} // Pass branch options here
        open={open}
        submit={submit}
        isLoading={isLoadingAdd}
        handleChange={OnChange}
        handleSubmit={onSubmit}
        handleClose={handleClose}
        btnName={isLoadingAdd ? "Wait" : tip?.id ? "Update" : "Submit"}
        value={tip}
      />
      <DashTable
        {...props}
        customer={response}
        onHandleEdit={onHandleEdit}
        isLoading={loadinglist}
      />
      {!loadinglist && <Pagination {...props} data={response} />}
    </>
  );
}

export default TipList;
